module.exports = __webpack_public_path__ + "static/img/touxiang@2x.4b4ef69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang@2x.png
// module id = bw4U
// module chunks = 1